/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { SvenskdamStandaloneNavigation as ResolvedStandaloneNavigation } from 'sites/svenskdam/components/standalone/Navigation';

export const Navigation: typeof ResolvedStandaloneNavigation = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneNavigation {...props} />
    );
});

export type NavigationProps = PropsFromComponent<typeof Navigation>;

/** @deprecated Use slot architecture instead */
export const NavigationWith = (extras: DynamicStandaloneExtras): typeof Navigation => {
    return function Navigation(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Navigation');
        return <ResolvedStandaloneNavigation {...mergeProps({ options: { theme } }, props)} />;
    }
}